<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg bg-body-tertiary fixed-top">
      <div class="container">
        <router-link class="navbar-brand" to="/">Guavas.link</router-link>
        <div class="d-flex flex-row">
          <a class="nav-link me-2" aria-current="page" href="./Home.html">Home</a>
          <router-link class="nav-link active" to="/">Articles</router-link>
        </div>
        <div class="d-flex">
          <router-link class="btn btn-sm btn-outline-info" v-if="$store.state.authenticated"
            to="/console">创作者中心</router-link>
          <router-link class="btn btn-sm btn-outline-info" v-if="!$store.state.authenticated" to="/login">{{
            this.$t('lang.toolbar.Login') }}</router-link>
        </div>
      </div>
    </nav>

    <main class="mainview container">
      <router-view />
    </main>

    <footer class="pt-3 mt-4 text-muted border-top">
      &copy;2024 - All Rights Reserved.
    </footer>

    <Toast></Toast>
    <Waiting></Waiting>
    <ModalConfirm></ModalConfirm>
    <ModalConfirm2></ModalConfirm2>
  </div>
</template>
<script>
import tp from "./utils/templete.js";
import Toast from './components/Toast.vue'
import Waiting from './components/ModalWaiting.vue'
import ModalConfirm from './components/ModalConfirm.vue'
import ModalConfirm2 from './components/ModalConfirm2.vue'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $
export default {
  components: {
    Toast,
    ModalConfirm,
    ModalConfirm2,
    Waiting
  },
  watch: {
  },
  created() {
    const that = this
    that.$store.state.tp = tp;
  },
  mounted() {
    const that = this
    that.onResize();
    $(window).resize(function () {
      that.onResize();
    });
    that.$i18n.locale = "zh"
    that.$store.state.confirmdef2 = {
      title: that.$t('lang.toolbar.Confirm'),
      msg: that.$t('lang.msg.toLogout'),
      event: 'logout'
    }
    this.$store.state.authenticated = JSON.parse(localStorage.getItem('authenticated') || false)
    this.$store.state.userinfo = JSON.parse(localStorage.getItem('userinfo') || '{}')
  },
  methods: {
    onResize() {
      var h = $(window).height();
      var h2 = h - 140;
      $(".mainview").css("min-height", h2);
    }
  }
}
</script>
<style>
#app {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: azure;
}

nav a {
  color: #2c3e50;
  margin-right: 0px;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.mainview {
  margin-top: 60px;
}

.main {
  padding: 20px 15px 20px 5px;
}
</style>
